import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainSectoion from './pages/MainSectoion.jsx'
import FeatureSingle from './pages/Features/FeaturesSingle.jsx';
import PricingSingle from './pages/Pricing/PricingSingle.jsx'
import About from './pages/About/index.jsx'
import Contact from './pages/Contact/index.jsx';
import EarlyAccess from './pages/EarlyAccess/index.jsx'
import Blog from './pages/Blog/index.jsx';
import Careers from './pages/Careers/index.jsx';
import HelpCenter from './pages/HelpCenter/index.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy/index.jsx';
import TermsOfService from './pages/TermsOfService/index.jsx';
import TrustSecurity from './pages/Trust/index.jsx';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<MainSectoion />} />
            <Route path="/features" element={<FeatureSingle />} />
            <Route path="/pricing" element={<PricingSingle />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/early-access" element={<EarlyAccess />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/trust" element={<TrustSecurity />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
